import { render, staticRenderFns } from "./SettingDialog.vue?vue&type=template&id=5d70e2b2&scoped=true&"
import script from "./SettingDialog.vue?vue&type=script&lang=ts&"
export * from "./SettingDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SettingDialog.vue?vue&type=style&index=0&id=5d70e2b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d70e2b2",
  null
  
)

export default component.exports